import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { keysLocalStorage } from 'src/constant/keys_localstorage';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    try {
        const user = await firstValueFrom(authService.isAuthenticated$);

        if (!user) {
            const finishedWelcome = JSON.parse(
                localStorage.getItem(keysLocalStorage.finishedWelcome),
            );
            if (!finishedWelcome) {
                await router.navigate(['/welcome'], { replaceUrl: true });
                return false;
            }

            const attemptedUrl = route.routeConfig?.path || '';
            const redirectPath = attemptedUrl ? `/${attemptedUrl}` : '/tabs/home';

            await router.navigate(['/login'], {
                queryParams: { redirect: redirectPath },
                replaceUrl: true,
            });

            return false;
        }

        // Usuário autenticado - permite acesso (manutenção é tratada pelo UpdateAppService)
        // Admins sempre têm acesso, mesmo em manutenção
        return true;
    } catch (error) {
        console.error('[AuthGuard] Erro ao verificar autenticação:', error);

        await router.navigate(['/login'], {
            queryParams: { redirect: route.routeConfig?.path || '' },
        });

        return false;
    }
};
